import { type RefObject } from "react";

export interface ITabFenceProps {
  targetRef: RefObject<any> | any; // Support both React Ref API: createRef or callback
}

/**
 * Tab fence element
 */
export default function TabFence(props: ITabFenceProps) {
  function focusTarget() {
    const target = props.targetRef && (props.targetRef.current || props.targetRef);

    if (target?.focus) {
      target.focus();
    }
  }

  return <div style={{ width: 0, height: 0 }} onFocus={focusTarget} tabIndex={0} />;
}
